import {
  IAuthor,
  IAuthorJournalInfo
} from '@publishing-engine/domain/types/AuthorType';
type JournalReviewerResult = {
  journalName: string | undefined;
  isReviewer: boolean;
};

type ReviewerJournalsResult = {
  journals: IAuthorJournalInfo[];
  isReviewer: boolean;
};

export function getJournalReviewer(
  authorData: IAuthor | undefined,
  submissionContextId: string
): JournalReviewerResult {
  const journal = authorData?.journals?.find(p => p.id === submissionContextId);

  if (!journal) {
    return { journalName: undefined, isReviewer: false };
  }

  return {
    journalName: journal.name, // journal name
    isReviewer: journal.roles.includes('reviewer')
  };
}

export function getReviewerJournals(
  authorData: IAuthor | undefined
): ReviewerJournalsResult {
  const reviewerJournals =
    authorData?.journals?.filter(journal =>
      journal.roles.includes('reviewer')
    ) || [];

  return {
    journals: reviewerJournals,
    isReviewer: reviewerJournals.length > 0
  };
}
